module.exports = __webpack_public_path__ + "static/media/dnd.38e32851.svg";